// All in Pictures

import initHeadroom from '~/javascripts/ai_headroom.js'
import initLazyLoadImages from '~/javascripts/lazy_load_images'
import initNav from '~/javascripts/nav.js'
import { initTileLoading, initTileSizing } from '~/javascripts/tiles'

// detect if there is a touch-screen present, grayscale filter is only for mouseover
if ('ontouchstart' in document.documentElement) {
  document.documentElement.classList.add('touch')
} else {
  document.documentElement.classList.add('no-touch')
}

document.addEventListener('DOMContentLoaded', () => {
  initTileSizing()
  initLazyLoadImages()
  initHeadroom()
  initNav()
})

document.addEventListener('readystatechange', (event) => {
  if (event.target.readyState === 'complete') {
    // console.log('CSS is loaded thus grid is calculated');
    initTileLoading()
  }
})

import { listen } from 'quicklink'

listen()
